interface Column {
  property: string;
  seqNo?: number;
  headerText?: string;
  precision?: number;
  display?: boolean;
  percentFlg?: boolean;
  statTableId?: number;
  toolTipText?: string;
  leadingZeroFlg?: boolean;
}

interface StatsMetaData {
  statsMetaData: [
    {
      columns: Column[];
    },
  ];
}

export function getColumnMetadata(
  accessor: string,
  statsMetaData: StatsMetaData,
  statTableId?: number
) {
  if (!statsMetaData?.statsMetaData?.[0]?.columns) return null;

  const snakeCase = accessor.replace(
    /[A-Z]/g,
    (letter: string) => `_${letter.toLowerCase()}`,
  );

  // Filter by both property name and statTableId if provided
  return statsMetaData.statsMetaData[0].columns.find(
    (col: Column) => 
      (col.property === snakeCase || col.property === accessor) && 
      (statTableId === undefined || col.statTableId === statTableId)
  );
}
